import React from 'react';
import { motion } from 'framer-motion';

const RSVPForm: React.FC = () => {

  

  return (
    <section id="rsvp" className="py-10 bg-gradient-to-br from-sand-300 to-sand-300">
      <div className="container-max section-padding">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="font-wasted text-4xl font-normal text-wedding-primary mb-2">
            Confirmación de asistencia
          </h2>
          <p className="font-avenir text-lg md:text-xl text-forest-800 max-w-3xl mx-auto">
          <br/>
          ¡Estamos deseando compartir nuestro gran día contigo! <br/>
          Si aún no lo has hecho, por favor, confirma tu asistencia y cuéntanos si tienes alguna alergia, intolerancia o necesitas un menú especial a través del siguiente enlace:
          <br/>
          <br/>
          <a href="http://bit.ly/4wRVkQD" target="_blank" rel="noopener noreferrer" className="text-forest-800 hover:text-forest-800 underline">http://bit.ly/4wRVkQD</a>
          </p>
        </motion.div>

       
      </div>

     
    </section>
  );
};

export default RSVPForm;

         